// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DevLoginRouteImport } from './routes/dev/login'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedFriendsRouteImport } from './routes/_authenticated/friends'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedBalancesRouteImport } from './routes/_authenticated/balances'
import { Route as AuthenticatedSettlementsIndexRouteImport } from './routes/_authenticated/settlements/index'
import { Route as AuthenticatedExpensesIndexRouteImport } from './routes/_authenticated/expenses/index'
import { Route as AuthenticatedSettlementsNewRouteImport } from './routes/_authenticated/settlements/new'
import { Route as AuthenticatedSettlementsIdRouteImport } from './routes/_authenticated/settlements/$id'
import { Route as AuthenticatedExpensesNewRouteImport } from './routes/_authenticated/expenses/new'
import { Route as AuthenticatedExpensesBulkRouteImport } from './routes/_authenticated/expenses/bulk'
import { Route as AuthenticatedExpensesIdRouteImport } from './routes/_authenticated/expenses/$id'

const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DevLoginRoute = DevLoginRouteImport.update({
            id: '/dev/login',path: '/dev/login',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedFriendsRoute = AuthenticatedFriendsRouteImport.update({
            id: '/friends',path: '/friends',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBalancesRoute = AuthenticatedBalancesRouteImport.update({
            id: '/balances',path: '/balances',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettlementsIndexRoute = AuthenticatedSettlementsIndexRouteImport.update({
            id: '/settlements/',path: '/settlements/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedExpensesIndexRoute = AuthenticatedExpensesIndexRouteImport.update({
            id: '/expenses/',path: '/expenses/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettlementsNewRoute = AuthenticatedSettlementsNewRouteImport.update({
            id: '/settlements/new',path: '/settlements/new',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettlementsIdRoute = AuthenticatedSettlementsIdRouteImport.update({
            id: '/settlements/$id',path: '/settlements/$id',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedExpensesNewRoute = AuthenticatedExpensesNewRouteImport.update({
            id: '/expenses/new',path: '/expenses/new',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedExpensesBulkRoute = AuthenticatedExpensesBulkRouteImport.update({
            id: '/expenses/bulk',path: '/expenses/bulk',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedExpensesIdRoute = AuthenticatedExpensesIdRouteImport.update({
            id: '/expenses/$id',path: '/expenses/$id',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedRouteChildren = {
  AuthenticatedBalancesRoute: AuthenticatedBalancesRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedFriendsRoute: AuthenticatedFriendsRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedExpensesIdRoute: AuthenticatedExpensesIdRoute,AuthenticatedExpensesBulkRoute: AuthenticatedExpensesBulkRoute,AuthenticatedExpensesNewRoute: AuthenticatedExpensesNewRoute,AuthenticatedSettlementsIdRoute: AuthenticatedSettlementsIdRoute,AuthenticatedSettlementsNewRoute: AuthenticatedSettlementsNewRoute,AuthenticatedExpensesIndexRoute: AuthenticatedExpensesIndexRoute,AuthenticatedSettlementsIndexRoute: AuthenticatedSettlementsIndexRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,LoginRoute: LoginRoute,PrivacyRoute: PrivacyRoute,AuthCallbackRoute: AuthCallbackRoute,DevLoginRoute: DevLoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)